<div class="header-button">
  @if (showToggleMenu) {
    <button mat-button class="header-item sidebar-collapse" (click)="toggleMenu()">

      <a class="pc-head-link">
        <i class="ti ti-menu-2" [style.color]="invertColor? 'white': ''"></i>
      </a>
    </button>
  }
  <div class="header-item ">
    <div class="header-title">
      @for (breadcrumb of navigationList; track breadcrumb; let last = $last) {
        @if (last && breadcrumb.breadcrumbs !== false) {
          <div class="flex align-item-center">
            <ul class="breadcrumb align-item-center">
              <li class="breadcrumb-item always-show">
                <a [routerLink]="['/dashboard/default']" title="Home"><i class="ti ti-home-2 text-white"></i></a>
              </li>
              @for (breadcrumb of navigationList; track breadcrumb) {
                @if (breadcrumb.url !== false) {
                  <li class="breadcrumb-item always-show text-white">
                    <a [routerLink]="breadcrumb.url" class="text-white">{{ breadcrumb.title }}</a>
                  </li>
                }
                @if (breadcrumb.url === false && breadcrumb.type !== 'group') {
                  <li class="breadcrumb-item always-show text-white">
                    <a href="javascript:" class="text-white">{{ breadcrumb.title }}</a>
                  </li>
                }
              }
            </ul>
          </div>
        }
        @if (last) {
          <h2 class="f-w-500 text-white truncate text-ellipsis text-clip ">
            {{ breadcrumb.pageName || breadcrumb.title }}
          </h2>
        }
      }
    </div>


  </div>
</div>
